// app_client/src/store/useFinancialStore.js
import { create } from 'zustand';
import axios from 'axios';
import { toast } from 'react-hot-toast';

const getResponseList = (payload) => {
  const data = payload?.data;
  if (Array.isArray(data)) return data;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload)) return payload;
  return [];
};

const useFinancialStore = create((set, get) => ({
  accounts: [],
  loading: false,

  fetchAccounts: async () => {
    set({ loading: true });
    try {
      const response = await axios.get('/api/financial-accounts');
      set({ accounts: getResponseList(response.data), loading: false });
    } catch {
      toast.error("Hesaplar yüklenemedi");
      set({ loading: false });
    }
  },

  addAccount: async (data) => {
    try {
      const response = await axios.post('/api/financial-accounts', data);
      set({ accounts: [...(Array.isArray(get().accounts) ? get().accounts : []), response.data.data] });
      toast.success("Hesap başarıyla eklendi");
      return true;
    } catch (err) {
      toast.error(err.response?.data?.message || "Ekleme hatası");
      return false;
    }
  },

  updateAccount: async (id, data) => {
    try {
      const response = await axios.put(`/api/financial-accounts/${id}`, data);
      set({
        accounts: (Array.isArray(get().accounts) ? get().accounts : []).map(acc => acc._id === id ? response.data.data : acc)
      });
      toast.success("Hesap güncellendi");
      return true;
    } catch (err) {
      toast.error(err.response?.data?.message || "Güncelleme hatası");
      return false;
    }
  },

  deleteAccount: async (id) => {
    try {
      await axios.delete(`/api/financial-accounts/${id}`);
      set({ accounts: (Array.isArray(get().accounts) ? get().accounts : []).filter(a => a._id !== id) });
      toast.success("Hesap kapatıldı");
      return true;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || "Beklenmedik bir hata oluştu.";
      toast.error(errorMessage, { duration: 6000 });
      console.error("Detaylı Hata:", err);
      return false;
    }
  }
}));

export default useFinancialStore;
